import styled from 'styled-components';

export const ExpandableCardsSection = styled.div`
  border-radius: ${({ theme }) => theme.radius.s};
  display: flex;
  flex-direction: column;
  box-shadow: 0 3px 6px 0px rgba(0, 0, 0, 0.1);
`;

export const ExpandableCardsContainer = styled.div`
  height: ${({ theme }) => theme.height.h7};
  padding: ${({ theme }) => `0 ${theme.spacing.m}`};
  display: flex;
  align-content: center;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
`;

export const CardLine = styled.div`
  width: 50%;
`;

export const SubjectContainer = styled.div`
 padding: ${({ theme }) =>
    `0 ${theme.spacing.m} ${theme.spacing.m} ${theme.spacing.m}`};
`;
